import React from 'react';

// ─────────────────────────────────────────────────────────────────────
// highlightMatch — moved verbatim out of legacy/App.tsx. Highlights search
// hits in a string with the same yellow style as the player-name matches in
// UniversalMatchRow. Returns a plain string when there is no match, otherwise
// an array of React nodes (string fragments + <mark> elements).
//
// It returns JSX, so it lives here in the archive component module (not the
// React-free src/lib layer). It is shared by AllMatchesArchive (this folder)
// and ArchiveView (still in legacy/App.tsx) — the monolith re-imports it from
// this barrel so there is a single definition. Inline comment kept in the
// original Norwegian to preserve git blame.
// ─────────────────────────────────────────────────────────────────────
export function highlightMatch(text, query) {
  const str = String(text == null ? '' : text);
  const q = (query || '').trim();
  if (!q) return str;
  const lower = str.toLowerCase();
  const ql = q.toLowerCase();
  if (!lower.includes(ql)) return str;
  const parts = [];
  let i = 0;
  let key = 0;
  let idx = lower.indexOf(ql, i);
  while (idx !== -1) {
    if (idx > i) parts.push(str.slice(i, idx));
    parts.push(
      <mark
        key={key++}
        style={{
          background: '#fef9c3',
          color: 'inherit',
          padding: '0 2px',
          borderRadius: 3,
          boxShadow: '0 0 0 1px #fde047',
        }}
      >
        {str.slice(idx, idx + q.length)}
      </mark>,
    );
    i = idx + q.length;
    idx = lower.indexOf(ql, i);
  }
  if (i < str.length) parts.push(str.slice(i));
  return parts;
}
